import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import {
  Form,
  Input,
  notification,
  Row,
  Col,
  Button,
  Modal,
  Select,
  DatePicker,
  Upload,
  message,
  Spin,
  Tooltip,
  Divider,
  Checkbox,
  Table,
  Radio,
} from 'antd';
import * as userActions from '../../redux/actions/userActions';
import config from '../../config';
import { useDispatch } from 'react-redux';
import {
  filter,
  formItemLayout,
  handleBackendFormErrors,
  tailFormItemLayout,
  unexpectedError,
  PictureCell,
  showFilesList,
  showUploadFileList,
  parseDate,
  formatDate,
  handleFileChange,
  beforeUpload,
  getBase64,
} from '../../common_functions';
import UploadTrigger from '../../common_functions/UploadTrigger';
import UploadedCheck from '../../common_functions/UploadedCheck';

const Negative = props => {
  const dispatch = useDispatch();
  const { section, id } = useParams();
  const [negativeData, setNegativeData] = useState();
  const [loading, setLoading] = useState(false);
  // Preview Image
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [negFile, setNegFile] = useState();
  const [negativeID, setNegativeID] = useState(null);
  const [supportData, setSupportData] = useState([]);
  const [dimensions, setDimensions] = useState([]);
  //add for advance negative search
  const [artist, setArtist] = useState([]);
  const [negList, setNegList] = useState([]);
  const [open, setOpen] = useState(false);
  const [filterNegData, setFilterNegData] = useState([]);
  const [selectedNegative, setSelectedNegative] = useState(null);
  const filterFormRef = useRef(false);
  const [filesState, setFilesState] = useState({
    technique_doc: [],
  });
  //end
  const handleCancel = () => setPreviewVisible(false);
  const formRef = useRef('');
  /**Handle file change**/
  const handleImageChange = ({ fileList: newFile }) => {
    setNegFile(newFile);
  };

  const handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };
  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      //get negative list
      const { data: negatives } = await dispatch(
        userActions.getItems('object_negative', {
          fields: ['id,obj_name'],
          limit: '-1',
          sort: 'obj_name',
        })
      );
      setNegList(negatives);
      /**Get artist name*/
      let { data: artists } = await dispatch(
        userActions.getItems('Artist', {
          fields: ['id', 'First_Name', 'last_name'],
          sort: '-id',
          limit: -1,
        })
      );
      setArtist(artists);
      //get support table data
      const { data: supData } = await dispatch(
        userActions.getItems('support_table', {
          fields: ['id', 'type', 'name', 'fields', 'description'],
          limit: -1,
          filters: {
            fields: {
              _in: ['work_process_neg', 'material_neg', 'relationship_type'],
            },
          },
        })
      );
      setSupportData(supData);
      //get sheet dimension table data
      const sheetDimensions = await dispatch(
        userActions.getItems('sheet_dimensions', {
          fields: ['id', 'label'],
          limit: -1,
        })
      );
      setDimensions(sheetDimensions.data);
      if (!!props.collectionObject.negative) {
        /**get all field data if negative is available**/
        let { data } = await dispatch(
          userActions.getItem('object_negative', props.collectionObject.negative, {
            fields: ['*', 'technique_doc.id', 'technique_doc.filename_download', 'thumbnail.id', 'thumbnail.filename_download'],
          })
        );
        setNegativeID(data.id);
        props.negID(data.id);
        if (data?.thumbnail?.id) {
          const fileData = await dispatch(userActions.getFile(data.thumbnail.id));
          setNegFile([
            {
              uid: data.thumbnail.id,
              name: data.thumbnail.filename_download,
              url: fileData,
            },
          ]);
        }
        setFilesState({
          technique_doc: showUploadFileList(data?.technique_doc?.id, data?.technique_doc?.filename_download),
        });
        data.technique_doc = data?.technique_doc?.id;
        data.thumbnail = data?.thumbnail?.id;
        data.creation_earliest = parseDate(data.creation_earliest);
        data.creation_latest = parseDate(data.creation_latest);
        setNegativeData(data);
        formRef?.current?.setFieldsValue(data);
        setLoading(false);
      }
      /**Set collection id and title*/
      formRef?.current?.setFieldsValue({
        acquisition: props.collectionObject.acquisition,
        collection_name: props.collectionObject.title,
      });
      setLoading(false);
    }
    fetchData();
  }, [section, props.collectionObject]);

  let onFinish = async values => {
    setLoading(true);
    // Convert the date object
    values.creation_earliest = formatDate(values.creation_earliest);
    values.creation_latest = formatDate(values.creation_latest);

    // Form data
    const formData = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      if (value?.fileList?.length > 0) {
        formData.append(key, value.fileList[0].originFileObj);
      } else {
        formData.append(key, value);
      }
    });

    formData.append('collection_id', props.collectionObject.collections);
    formData.append('object_id', props.collectionObject.id);

    try {
      const response = await dispatch(userActions.collectionObject(formData, 'negative/object_negative', negativeID));
      if (response) {
        if (response.error) {
          notification['error']({
            message: response.error,
            duration: 2,
          });
        } else {
          let data = response.data;
          if (data?.thumbnail?.id) {
            const fileData = await dispatch(userActions.getFile(data.thumbnail.id));
            setNegFile([
              {
                uid: data.thumbnail.id,
                name: data.thumbnail.filename_download,
                url: fileData,
              },
            ]);
          }

          data.creation_earliest = parseDate(data.creation_earliest);
          data.creation_latest = parseDate(data.creation_latest);

          setNegativeData(data);
          formRef?.current?.setFieldsValue(data);
          formRef?.current?.resetFields(['technique_doc', 'thumbnail']);
          formRef?.current?.setFieldsValue({
            technique_doc: data.technique_doc,
            thumbnail: data.thumbnail,
          });
          props.negID(data.id);
          props.setAllObjectData({
            ...props.collectionObject,
            negative: data.id,
          });
          notification['success']({
            message: 'Negative saved successfully!',
            duration: 2,
          });
          props.onChange('3', 'Image Description');
        }
      }
    } catch (errorResponse) {
      handleBackendFormErrors(formRef, errorResponse);
    } finally {
      setLoading(false);
    }
  };

  let onFinishFailed = async ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };
  let backButton = () => {
    props.onChange('1', 'Edit Object');
  };
  const showModal = () => {
    formRef?.current?.setFieldsValue({ related_negative: selectedNegative });
    setOpen(true);
  };
  const cancelFilterModal = () => {
    setOpen(false);
    filterFormRef?.current?.setFieldsValue('');
  };
  const handleModalOk = () => {
    formRef?.current?.setFieldsValue({ related_negative: selectedNegative });
    cancelFilterModal();
  };
  const columns = [
    {
      title: 'Thumbnail',
      dataIndex: 'thumbnail',
      key: 'thumbnail',
      render: (text, record) =>
        text ? (
          <PictureCell dataIndexValue={text} getFile={() => dispatch(userActions.getFile(record.thumbnail))} record={record} width={50} />
        ) : (
          <span>-</span>
        ),
    },
    {
      title: 'Collection Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      ...filter('name'),
      onFilter: (value, record) => record.name.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Common Title',
      dataIndex: 'obj_name',
      key: 'obj_name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      ...filter('obj_name'),
      onFilter: (value, record) => record.obj_name.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Acquisition id',
      dataIndex: 'acquisition',
      key: 'acquisition',
      ...filter('acquisition'),
      onFilter: (value, record) => record.acquisition.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Select',
      key: 'select',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            {
              // Hide delete and edit permission for readonly user
              props.roleType !== 'readOnly' ? (
                <>
                  <Tooltip placement="top" title="Select Negative">
                    <Radio.Group value={selectedNegative} onChange={event => negFilter(event.target.value, record)}>
                      <Radio value={record.id} onClick={event => negFilter(event.target.value, record)} />
                    </Radio.Group>
                  </Tooltip>
                </>
              ) : (
                ''
              ) // end here
            }
          </div>
        </span>
      ),
    },
  ];
  const negFilter = (record, data) => {
    selectedNegative == record ? setSelectedNegative(null) : setSelectedNegative(record);
    formRef?.current?.setFieldsValue({ related_negative: selectedNegative });
  };
  const onFinishFilter = async values => {
    try {
      setLoading(true);
      const { data: negData } = await dispatch(userActions.negativeFilter(values));
      setFilterNegData(negData);
    } catch (error) {
      console.log(error);
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };
  const onFinishFilterFailed = ({ errorFields }) => {
    filterFormRef.current.scrollToField(errorFields[0].name);
  };
  return (
    <Spin spinning={loading} size="large">
      <Form
        ref={formRef}
        layout="vertical"
        {...formItemLayout}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{ layout: tailFormItemLayout }}
      >
        <Row gutter={24}>
          <Col xs={24} sm={24} md={24} lg={24}>
            <Form.Item name="dummy" label="" valuePropName="checked">
              <Checkbox> This is an incomplete negative record that will need to be updated.</Checkbox>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} style={{ display: 'none' }}>
            <Form.Item
              name="acquisition"
              label="Collection Acquisition #"
              rules={[
                {
                  required: true,
                  message: 'Collection acquisition # is required',
                },
              ]}
            >
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} style={{ display: 'none' }}>
            <Form.Item
              name="collection_name"
              label="Collection Title (Title per Collection Record)"
              rules={[
                {
                  required: true,
                  message: 'Collection title is required',
                },
              ]}
            >
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>
        {/* <Divider /> */}
        <Row gutter={24}>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item
              name="obj_name"
              label="Common Title"
              rules={[
                {
                  whitespace: true,
                  required: true,
                  message: 'Common title is required',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="alt_obj_name" label="Alt Object Name / Title">
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item
              name="creation_earliest"
              label="Negative Creation Date Earliest"
              rules={[
                {
                  validator: async (_, creation_earliest) => {
                    var endDatetime = formRef.current.getFieldValue('creation_latest');
                    if (!!endDatetime && !!creation_earliest && creation_earliest.format('YYYY') > endDatetime.format('YYYY'))
                      return formRef?.current?.setFieldsValue({
                        creation_latest: '',
                      });
                  },
                },
              ]}
            >
              <DatePicker picker="year" placeholder="Start year" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item
              name="creation_latest"
              label="Negative Creation Date Latest"
              rules={[
                {
                  validator: async (_, creation_latest) => {
                    var startDatetime = formRef.current.getFieldValue('creation_earliest');
                    if (!!startDatetime && !!creation_latest && creation_latest.format('YYYY') < startDatetime.format('YYYY'))
                      return formRef?.current?.setFieldsValue({
                        creation_earliest: '',
                      });
                  },
                },
              ]}
            >
              <DatePicker picker="year" placeholder="End year" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="negative_id" label="Artist Negative ID">
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="secondary_negative_id" label="Secondary Negative ID">
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="sheet_dimensions" label="Sheet Dimension (Width X Height)">
              <Select
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                placeholder="Select a sheet dimension (width x height)"
              >
                {dimensions.map(item => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="obj_desc" label="Object description">
              <Input.TextArea placeholder="Object Description" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item
              name="work_type_neg"
              label="Work Type, Negative Type"
              rules={[
                {
                  required: true,
                  message: 'Work type, negative type is required!',
                },
              ]}
            >
              <Select
                showSearch
                allowClear
                placeholder="Select a work type, negative type"
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
              >
                {supportData.map(
                  el =>
                    el.fields === 'work_process_neg' && (
                      <Select.Option key={el.id} value={el.id}>
                        {el.name}
                      </Select.Option>
                    )
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="materials" label="Work Type, Negative Materials">
              <Select
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                placeholder="Select a work type, negative materials"
              >
                {supportData.map(
                  el =>
                    el.fields === 'material_neg' && (
                      <Select.Option key={el.id} value={el.id}>
                        {el.name}
                      </Select.Option>
                    )
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="techniques" label="Techniques">
              <Input placeholder="Enter Techniques" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="materials_detail" label="Materials Detail">
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item
              name="technique_doc"
              label={
                <div>
                  Technique Documentation
                  <UploadedCheck uploaded={!!negativeData && negativeData.technique_doc} />
                </div>
              }
            >
              <Upload
                name="file"
                fileList={filesState.technique_doc}
                className="create_object"
                accept={config.FileType.docType.toString()}
                beforeUpload={file => {
                  return beforeUpload(file, 'docType');
                }}
                maxCount={1}
                multiple={false}
                onChange={e => {
                  handleFileChange(e, setFilesState, 'technique_doc');
                }}
                showUploadList={showFilesList(negativeData?.technique_doc, 'Technique Documentation')}
              >
                <UploadTrigger fileType="docType" />
              </Upload>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="thumbnail" label="Thumbnail">
              <Upload
                name="file"
                listType="picture"
                className="create_object"
                accept={config.FileType.imageType.toString()}
                beforeUpload={beforeUpload}
                fileList={negFile}
                showUploadList={{
                  showRemoveIcon: negativeData?.thumbnail ? false : true,
                }}
                onPreview={handlePreview}
                maxCount={1}
                multiple={false}
                onChange={handleImageChange}
              >
                <UploadTrigger fileType="imageType" />
              </Upload>
            </Form.Item>
            <Modal open={previewVisible} title={previewTitle} footer={null} onCancel={handleCancel}>
              <div style={{ textAlign: 'center' }}>
                <img
                  alt="No Thumbnail"
                  style={{
                    width: '100%',
                    height: 'auto',
                    textAlign: 'center',
                  }}
                  src={previewImage}
                />
              </div>
            </Modal>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="notes" label="Notes">
              <Input.TextArea placeholder="Notes..." />
            </Form.Item>
          </Col>
        </Row>
        <Divider />
        <Row gutter={24}>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="relationship_type" label="Relationship Type">
              <Select
                showSearch
                allowClear
                placeholder="Enter relationship type"
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
              >
                {supportData.map(
                  el =>
                    el.type === 'relationship type' && (
                      <Select.Option key={el.id} value={el.id}>
                        {el.name}
                      </Select.Option>
                    )
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item
              name="related_negative"
              className="labelLink"
              label={
                <div
                  style={{
                    justifyContent: 'space-between',
                    width: '100%',
                    textAlign: 'center',
                    display: 'flex',
                  }}
                >
                  Negative
                  <Tooltip placement="rightTop" title="Advance Negative Search">
                    <a style={{ color: '#a6a300', cusrsor: 'pointer' }} onClick={showModal}>
                      Advance filter
                    </a>
                  </Tooltip>
                </div>
              }
            >
              <Select
                showSearch
                allowClear
                placeholder="Enter Negative"
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
              >
                {negList
                  .filter(el => props.collectionObject.negative !== el.id)
                  .map(el => (
                    <Select.Option key={el.id} value={el.id}>
                      {el.obj_name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item {...tailFormItemLayout}>
          <Button
            style={{
              margin: '0 8px',
              backgroundColor: 'lightgrey',
              color: '#333',
              borderColor: '#333',
            }}
            onClick={backButton}
          >
            Back
          </Button>
          {props.showButton()}
        </Form.Item>
      </Form>
      {/* modal for advance search */}

      <Modal
        title="Advance Negative Filter"
        open={open}
        footer={[
          <Button
            style={{
              margin: '0 8px',
              backgroundColor: 'lightgrey',
              color: '#333',
              borderColor: '#333',
            }}
            onClick={cancelFilterModal}
          >
            Close
          </Button>,
          <Button key="submit" type="primary" loading={loading} onClick={handleModalOk}>
            Ok
          </Button>,
        ]}
        confirmLoading={loading}
        onCancel={cancelFilterModal}
        width={1200}
      >
        <div>
          <Form
            ref={filterFormRef}
            layout="vertical"
            {...formItemLayout}
            onFinish={onFinishFilter}
            onFinishFailed={onFinishFilterFailed}
            initialValues={{ layout: tailFormItemLayout }}
          >
            <Row gutter={24}>
              <Col xs={24} sm={6} md={6} lg={6}>
                <Form.Item name="keyword" label="Keyword">
                  <Input placeholder="Type... " />
                </Form.Item>
              </Col>
              <Col xs={24} sm={6} md={6} lg={6}>
                <Form.Item name="obj_name" label="Common Title">
                  <Input placeholder="Type..." />
                </Form.Item>
              </Col>
              <Col xs={24} sm={6} md={6} lg={6}>
                <Form.Item name="creator" label="Artist / Creator">
                  <Select showSearch allowClear placeholder="Select artist" optionFilterProp="children">
                    {artist.map(val => (
                      <Select.Option key={val.id} value={val.id}>
                        {val.First_Name} {val.last_name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={6} md={6} lg={6}>
                <Form.Item>
                  <Button className="save-btn" type="primary" style={{ margin: '25px 8px' }} htmlType="submit">
                    Search
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Row gutter={24}>
            <Col xs={24} sm={24} md={24} lg={24}>
              <hr />
              <div className="artist-list" id="negative_filter_table">
                <Table
                  className="no-fixed-last-col"
                  scroll={{ x: 'max-content' }}
                  columns={columns}
                  bordered
                  rowKey={record => record.id}
                  dataSource={filterNegData}
                  loading={loading}
                />
              </div>
            </Col>
          </Row>
        </div>
      </Modal>

      {/* end advance filter modal */}
    </Spin>
  );
};

export default Negative;
